import React, { useState, useEffect } from 'react';
import { useLang } from '@/lib/i18n';
import {
  Smartphone,
  Download,
  Share,
  PlusSquare,
  X,
  Check,
  Zap,
  Shield,
  Sparkles,
  ArrowDown
} from 'lucide-react';

const TEXTS = {
  pl: {
    badge: 'Aplikacja Webowa PWA',
    title: 'Zainstaluj SecretGirls',
    subtitle: 'Dodaj aplikację na ekran główny telefonu dla natychmiastowego i dyskretnego dostępu.',
    feature1: 'Błyskawiczny start (1 kliknięcie bez wpisywania adresu)',
    feature2: '100% dyskrecji (ikona aplikacji bezpośrednio na pulpicie)',
    feature3: 'Płynne działanie i oszczędność transferu danych',
    btnInstall: 'Zainstaluj aplikację',
    btnLater: 'Przypomnij później',
    iosTitle: 'Jak zainstalować na iPhone / iPad',
    iosSubtitle: 'Postępuj zgodnie z 3 prostymi krokami w przeglądarce Safari:',
    iosStep1Title: 'Krok 1: Kliknij ikonę Udostępnij',
    iosStep1Desc: 'Naciśnij przycisk udostępniania (kwadrat ze strzałką) na dolnym pasku Safari.',
    iosStep2Title: 'Krok 2: Wybierz «Do ekranu początkowego»',
    iosStep2Desc: 'Przewiń listę opcji w dół i wybierz opcję z ikoną plusa.',
    iosStep3Title: 'Krok 3: Potwierdź klikając «Dodaj»',
    iosStep3Desc: 'W prawym górnym rogu kliknij Dodaj. Gotowe! Ikona pojawi się na Twoim ekranie.',
    iosClose: 'Rozumiem',
    androidFallback: 'Kliknij ikonę menu (trzy kropki ⋮ w prawym górnym rogu) i wybierz «Zainstaluj aplikację».',
    installedToast: 'Aplikacja SecretGirls została pomyślnie zainstalowana!'
  },
  ru: {
    badge: 'Мобильное приложение PWA',
    title: 'Установить SecretGirls',
    subtitle: 'Добавьте приложение на главный экран для быстрого, приватного и удобного доступа.',
    feature1: 'Мгновенный запуск в 1 клик без браузерной строки',
    feature2: '100% приватность (стильная иконка на экране смартфона)',
    feature3: 'Плавная работа, экономия трафика и высокая скорость',
    btnInstall: 'Установить приложение',
    btnLater: 'Позже',
    iosTitle: 'Как установить на iPhone / iPad',
    iosSubtitle: 'Выполните 3 простых шага в браузере Safari:',
    iosStep1Title: 'Шаг 1: Нажмите «Поделиться»',
    iosStep1Desc: 'Нажмите кнопку с квадратом и стрелкой вверх на нижней панели Safari.',
    iosStep2Title: 'Шаг 2: «На экран «Домой»»',
    iosStep2Desc: 'Прокрутите меню вниз и выберите пункт «На экран «Домой»».',
    iosStep3Title: 'Шаг 3: Нажмите «Добавить»',
    iosStep3Desc: 'В правом верхнем углу нажмите «Добавить». Иконка появится на вашем экране!',
    iosClose: 'Понятно',
    androidFallback: 'Нажмите меню браузера (три точки ⋮ вверху справа) и выберите «Установить приложение».',
    installedToast: 'Приложение SecretGirls успешно установлено!'
  },
  en: {
    badge: 'PWA Web App',
    title: 'Install SecretGirls',
    subtitle: 'Add the app to your home screen for instant, discreet, and fast access.',
    feature1: 'Instant 1-tap launch without browser address bar',
    feature2: '100% discreet (sleek app icon right on your screen)',
    feature3: 'Smooth performance and saved mobile data',
    btnInstall: 'Install App',
    btnLater: 'Maybe later',
    iosTitle: 'How to install on iPhone / iPad',
    iosSubtitle: 'Follow these 3 simple steps in Safari browser:',
    iosStep1Title: 'Step 1: Tap the Share button',
    iosStep1Desc: 'Tap the share icon (square with arrow) on Safari bottom toolbar.',
    iosStep2Title: 'Step 2: Tap "Add to Home Screen"',
    iosStep2Desc: 'Scroll down the menu and choose "Add to Home Screen" with the plus icon.',
    iosStep3Title: 'Step 3: Tap "Add"',
    iosStep3Desc: 'Tap Add in the top-right corner. All done! The app is on your screen.',
    iosClose: 'Got it',
    androidFallback: 'Tap the browser menu (three dots ⋮) and select "Install app".',
    installedToast: 'SecretGirls app installed successfully!'
  },
  ua: {
    badge: 'Мобільний додаток PWA',
    title: 'Встановити SecretGirls',
    subtitle: 'Додайте додаток на головний екран для швидкого, приватного та зручного доступу.',
    feature1: 'Миттєвий запуск в 1 клік без адресного рядка',
    feature2: '100% приватність (стильна іконка на робочому столі)',
    feature3: 'Плавна робота, економія трафіку та висока швидкість',
    btnInstall: 'Встановити додаток',
    btnLater: 'Пізніше',
    iosTitle: 'Як встановити на iPhone / iPad',
    iosSubtitle: 'Виконайте 3 прості кроки в браузері Safari:',
    iosStep1Title: 'Крок 1: Натисніть «Поділитися»',
    iosStep1Desc: 'Натисніть кнопку з квадратом і стрілкою вгору на нижній панелі Safari.',
    iosStep2Title: 'Крок 2: «На екран «Додому»»',
    iosStep2Desc: 'Прокрутіть меню вниз та виберіть пункт «На екран «Додому»».',
    iosStep3Title: 'Крок 3: Натисніть «Додати»',
    iosStep3Desc: 'У правому верхньому кутку натисніть «Додати». Додаток з\'явиться на екрані!',
    iosClose: 'Зрозуміло',
    androidFallback: 'Натисніть меню браузера (три крапки ⋮ вгорі) та виберіть «Встановити додаток».',
    installedToast: 'Додаток SecretGirls успішно встановлено!'
  }
};

export default function PwaInstallPrompt() {
  const { lang = 'pl' } = useLang() || {};
  const t = TEXTS[lang] || TEXTS.pl;

  const [isOpen, setIsOpen] = useState(false);
  const [showIosGuide, setShowIosGuide] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Detect standalone mode
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true ||
      document.referrer.includes('android-app://');
    setIsStandalone(standalone);
    if (standalone) return;

    // Detect iOS
    const ua = window.navigator.userAgent.toLowerCase();
    const isIosDevice = /iphone|ipad|ipod/.test(ua) && !window.MSStream;
    setIsIos(isIosDevice);

    // Listen for Android beforeinstallprompt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Listen for app installed
    const handleAppInstalled = () => {
      setIsOpen(false);
      setShowIosGuide(false);
      setIsStandalone(true);
      setDeferredPrompt(null);
    };
    window.addEventListener('appinstalled', handleAppInstalled);

    // Listen for custom trigger from buttons anywhere on site
    const handleManualOpen = () => {
      setIsOpen(true);
    };
    window.addEventListener('open-pwa-install', handleManualOpen);

    // Check if dismissed recently (snoozed for 3 days)
    const dismissedUntil = localStorage.getItem('sg_pwa_dismissed_until');
    const isSnoozed = dismissedUntil && Number(dismissedUntil) > Date.now();

    if (!isSnoozed) {
      // Gentle appearance delay so user sees site content first
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);
      return () => {
        clearTimeout(timer);
        window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
        window.removeEventListener('appinstalled', handleAppInstalled);
        window.removeEventListener('open-pwa-install', handleManualOpen);
      };
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('open-pwa-install', handleManualOpen);
    };
  }, []);

  const handleDismiss = () => {
    setIsOpen(false);
    setShowIosGuide(false);
    localStorage.setItem('sg_pwa_dismissed_until', String(Date.now() + 3 * 24 * 60 * 60 * 1000));
  };

  const handleInstallClick = async () => {
    if (isIos) {
      setShowIosGuide(true);
      return;
    }

    if (deferredPrompt) {
      try {
        deferredPrompt.prompt();
        const choice = await deferredPrompt.userChoice;
        if (choice && choice.outcome === 'accepted') {
          setIsOpen(false);
          setDeferredPrompt(null);
        }
      } catch (err) {
        console.warn('[PWA] Prompt error:', err);
      }
    } else {
      setShowIosGuide(true);
    }
  };

  if (isStandalone || !isOpen) return null;

  return (
    <>
      {/* Floating Prompt Card */}
      <aside
        aria-label={t.title}
        className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 pointer-events-auto transition-all duration-500 ease-out animate-in fade-in slide-in-from-bottom-8"
      >
        <div className="relative overflow-hidden rounded-3xl bg-[#0f0f12]/95 backdrop-blur-2xl border border-white/10 p-5 sm:p-6 shadow-2xl text-white">
          {/* Top highlight gradient line */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-rose-500 via-pink-500 to-amber-400" />

          {/* Close button */}
          <button
            onClick={handleDismiss}
            aria-label="Zamknij"
            className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-white/60 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>

          {/* Header block with Logo */}
          <div className="flex items-center gap-3.5 pr-8 mb-4">
            <div className="relative shrink-0">
              <img
                src="/logo192.png"
                alt="SecretGirls App Icon"
                className="w-14 h-14 rounded-2xl object-cover border border-white/15 shadow-lg shadow-black/80"
              />
              <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-rose-600 border-2 border-[#0f0f12] flex items-center justify-center">
                <Sparkles className="w-2.5 h-2.5 text-white" />
              </span>
            </div>
            <div>
              <div className="flex items-center gap-1.5 mb-0.5">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-rose-500/15 text-rose-300 border border-rose-500/25 uppercase tracking-wider">
                  <Zap className="w-2.5 h-2.5" /> {t.badge}
                </span>
                <span className="text-[11px] text-amber-300/90 font-medium">★ 4.9</span>
              </div>
              <h3 className="text-base font-bold text-white tracking-tight">{t.title}</h3>
              <p className="text-xs text-white/50 leading-tight">SecretGirls Escort</p>
            </div>
          </div>

          <p className="text-xs text-white/75 mb-3.5 leading-relaxed">
            {t.subtitle}
          </p>

          {/* Benefits bullets */}
          <ul className="space-y-1.5 mb-4 text-[11px] text-white/80">
            <li className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center shrink-0">
                <Check className="w-2.5 h-2.5" />
              </span>
              <span>{t.feature1}</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-rose-500/20 text-rose-400 flex items-center justify-center shrink-0">
                <Shield className="w-2.5 h-2.5" />
              </span>
              <span>{t.feature2}</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-amber-500/20 text-amber-400 flex items-center justify-center shrink-0">
                <Zap className="w-2.5 h-2.5" />
              </span>
              <span>{t.feature3}</span>
            </li>
          </ul>

          {/* Action buttons */}
          <div className="flex items-center gap-2.5">
            <button
              onClick={handleInstallClick}
              className="flex-1 py-3 px-4 rounded-2xl bg-gradient-to-r from-rose-600 via-pink-600 to-rose-700 hover:from-rose-500 hover:to-rose-600 text-white font-semibold text-xs sm:text-sm shadow-lg shadow-rose-950/50 flex items-center justify-center gap-2 transition-all active:scale-[0.98]"
            >
              <Download className="w-4 h-4" />
              <span>{t.btnInstall}</span>
            </button>
            <button
              onClick={handleDismiss}
              className="py-3 px-3.5 rounded-2xl bg-white/5 hover:bg-white/10 text-white/60 hover:text-white text-xs font-medium transition-colors"
            >
              {t.btnLater}
            </button>
          </div>
        </div>
      </aside>

      {/* iOS & Manual Installation Instruction Modal */}
      {showIosGuide && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-md flex items-end sm:items-center justify-center p-3 sm:p-4 animate-in fade-in duration-200"
        >
          <div className="relative w-full max-w-md rounded-3xl bg-[#121216] border border-white/15 p-5 sm:p-6 shadow-2xl text-white animate-in slide-in-from-bottom duration-300">
            {/* Modal header */}
            <div className="flex items-center justify-between pb-4 border-b border-white/10 mb-4">
              <div className="flex items-center gap-3">
                <img
                  src="/logo192.png"
                  alt="SecretGirls"
                  className="w-10 h-10 rounded-xl object-cover border border-white/10"
                />
                <div>
                  <h4 className="text-sm font-bold">{isIos ? t.iosTitle : t.title}</h4>
                  <p className="text-[11px] text-white/50">{isIos ? 'Safari iOS' : 'Android / Browser'}</p>
                </div>
              </div>
              <button
                onClick={() => setShowIosGuide(false)}
                className="w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-white/60 hover:text-white"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            {isIos ? (
              <>
                <p className="text-xs text-white/70 mb-4">{t.iosSubtitle}</p>
                <div className="space-y-3 mb-6">
                  {/* Step 1 */}
                  <div className="flex items-start gap-3 p-3 rounded-2xl bg-white/[0.04] border border-white/5">
                    <div className="w-9 h-9 rounded-xl bg-blue-500/20 text-blue-400 flex items-center justify-center shrink-0">
                      <Share className="w-5 h-5" />
                    </div>
                    <div>
                      <h5 className="text-xs font-semibold text-white mb-0.5">{t.iosStep1Title}</h5>
                      <p className="text-[11px] text-white/60 leading-relaxed">{t.iosStep1Desc}</p>
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div className="flex items-start gap-3 p-3 rounded-2xl bg-white/[0.04] border border-white/5">
                    <div className="w-9 h-9 rounded-xl bg-rose-500/20 text-rose-400 flex items-center justify-center shrink-0">
                      <PlusSquare className="w-5 h-5" />
                    </div>
                    <div>
                      <h5 className="text-xs font-semibold text-white mb-0.5">{t.iosStep2Title}</h5>
                      <p className="text-[11px] text-white/60 leading-relaxed">{t.iosStep2Desc}</p>
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div className="flex items-start gap-3 p-3 rounded-2xl bg-white/[0.04] border border-white/5">
                    <div className="w-9 h-9 rounded-xl bg-emerald-500/20 text-emerald-400 flex items-center justify-center shrink-0">
                      <Check className="w-5 h-5" />
                    </div>
                    <div>
                      <h5 className="text-xs font-semibold text-white mb-0.5">{t.iosStep3Title}</h5>
                      <p className="text-[11px] text-white/60 leading-relaxed">{t.iosStep3Desc}</p>
                    </div>
                  </div>
                </div>

                {/* Animated pointer indicator towards bottom toolbar on iPhone */}
                <div className="flex items-center justify-center gap-1.5 py-2 text-rose-400 text-xs font-medium animate-bounce mb-3">
                  <ArrowDown className="w-4 h-4" />
                  <span>Przycisk «Udostępnij» znajduje się na dolnym pasku Safari</span>
                  <ArrowDown className="w-4 h-4" />
                </div>
              </>
            ) : (
              <div className="py-4 text-center">
                <div className="w-14 h-14 rounded-2xl bg-rose-500/10 text-rose-400 flex items-center justify-center mx-auto mb-3">
                  <Smartphone className="w-7 h-7" />
                </div>
                <p className="text-xs text-white/80 leading-relaxed mb-4">
                  {t.androidFallback}
                </p>
              </div>
            )}

            <button
              onClick={() => {
                setShowIosGuide(false);
                setIsOpen(false);
              }}
              className="w-full py-3 rounded-2xl bg-white/10 hover:bg-white/15 text-white font-semibold text-xs sm:text-sm transition-colors"
            >
              {t.iosClose}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
